export const pdRoutes = [

        {
            path: 'pd/check/category', name: 'Pd-Manager-Category',
            component: resolve => require(['@/views/pd/check/category/Category.vue'], resolve), props: true,
            meta: {compPath: '/pd/check/category/Category.vue'}
        },
        {
            path: 'pd/check/checkRecord', name: 'Pd-Manager-Check-Record',
            component: resolve => require(['@/views/pd/check/checkRecord/CheckRecord.vue'], resolve), props: true,
            meta: {compPath: '/pd/check/checkRecord/CheckRecord.vue'}
        },
        {
            path: 'pd/maintenance/budget-cost', name: 'Pd-Manager-Budget-Cost',
            component: resolve => require(['@/views/pd/maintenance/budget-cost/BudgetCost.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/budget-cost/BudgetCost.vue'}
        },
        {
            path: 'pd/maintenance/budget-edition', name: 'Pd-Manager-Budget-Edition',
            component: resolve => require(['@/views/pd/maintenance/budget-edition/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/budget-edition/List.vue'}
        },
        {
            path: 'pd/maintenance/budget-matter', name: 'Pd-Manager-Budget-Matter',
            component: resolve => require(['@/views/pd/maintenance/budget-matter/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/budget-matter/List.vue'}
        },
        {
            path: 'pd/maintenance/budget-reach', name: 'Pd-Manager-Budget-Reach',
            component: resolve => require(['@/views/pd/maintenance/budget-reach/BudgetReach.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/budget-reach/BudgetReach.vue'}
        },
        {
            path: 'pd/maintenance/budget-reach', name: 'Pd-Manager-Point-Reach',
            component: resolve => require(['@/views/pd/inspection/xj-point/XjpointReach.vue'], resolve), props: true,
            meta: {compPath: '/pd/inspection/xj-point/XjpointReach.vue'}
        },        
        {
            path: 'pd/maintenance/budget-type', name: 'Pd-Manager-Budget-Type',
            component: resolve => require(['@/views/pd/maintenance/budget-type/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/budget-type/List.vue'}
        },
        {
            path: 'pd/maintenance/order-detail', name: 'Pd-Manager-Order-Detail',
            component: resolve => require(['@/views/pd/maintenance/order-detail/OrderDetail.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/order-detail/OrderDetail.vue'}
        },
        {
            path: 'pd/maintenance/plan-item', name: 'Pd-Manager-Plan-Item',
            component: resolve => require(['@/views/pd/maintenance/plan-item/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/plan-item/List.vue'}
        },
        {
            path: 'pd/maintenance/shop-plan', name: 'Pd-Manager-Shop-Plan',
            component: resolve => require(['@/views/pd/maintenance/shop-plan/ShopPlan.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/shop-plan/ShopPlan.vue'}
        },
        {
            path: 'pd/maintenance/plan-reach', name: 'Pd-Manager-Plan-Reach',
            component: resolve => require(['@/views/pd/maintenance/plan-reach/PlanReach.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/plan-reach/PlanReach.vue'}
        },
        {
            path: 'pd/maintenance/special-cost', name: 'Pd-Manager-Special-Cost',
            component: resolve => require(['@/views/pd/maintenance/special-cost/SpecialCost.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/special-cost/SpecialCost.vue'}
        },
        {
            path: 'pd/maintenance/staffing', name: 'Pd-Manager-Staffing',
            component: resolve => require(['@/views/pd/maintenance/staffing/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/staffing/List.vue'}
        },
        {
            path: 'pd/maintenance/subject', name: 'Pd-Manager-Subject',
            component: resolve => require(['@/views/pd/maintenance/subject/Subject.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/subject/Subject.vue'}
        },
        {
            path: 'pd/maintenance/role', name: 'Pd-Manager-Role',
            component: resolve => require(['@/views/pd/maintenance/role/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/maintenance/role/List.vue'}
        },
        {
            path: 'pd/inspection/scheduling', name: 'Pd-Manager-Scheduling',
            component: resolve => require(['@/views/pd/inspection/scheduling/Scheduling.vue'], resolve), props: true,
            meta: {compPath: '/pd/inspection/scheduling/Scheduling.vue'}
        },
        {
            path: 'pd/inspection/shop-point', name: 'Pd-Manager-Shop-Point',
            component: resolve => require(['@/views/pd/inspection/shop-point/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/inspection/shop-point/List.vue'}
        },
        {
            path: 'pd/inspection/task', name: 'Pd-Manager-Task',
            component: resolve => require(['@/views/pd/inspection/task/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/inspection/task/List.vue'}
        },
        {
            path: 'pd/inspection/xjorder', name: 'Pd-Manager-Xj-Order',
            component: resolve => require(['@/views/pd/inspection/xjorder/XjOrder.vue'], resolve), props: true,
            meta: {compPath: '/pd/inspection/xjorder/XjOrder.vue'}
        },
        {
            path: 'pd/inspection/transfer', name: 'Pd-Manager-Xjorder-Transfer',
            component: resolve => require(['@/views/pd/inspection/transfer/List.vue'], resolve), props: true,
            meta: {compPath: '/pd/inspection/transfer/List.vue'}
        },
    ]
; 